module.exports = __webpack_public_path__ + "img/plus.ba184198.svg";